import { createIsolation } from 'jotai-scope';
import { atomWithReducer } from 'jotai/utils';

import { assertUnreachable } from '../../../../../util/assertUnreachable';

export enum GenerateQuestionStep {
  Settings = 1,
  Questions = 2,
}

const MAX_NUMBER_OF_STEPS = 2;

type ChangeStepAction = { type: 'NextStep' } | { type: 'PreviousStep' };

function stepReducer(state: GenerateQuestionStep, action: ChangeStepAction) {
  switch (action.type) {
    case 'NextStep': {
      return Math.min(state + 1, MAX_NUMBER_OF_STEPS);
    }
    case 'PreviousStep': {
      return Math.max(state - 1, 1);
    }
    default:
      assertUnreachable(action);
  }
}

const stepAtom = atomWithReducer<GenerateQuestionStep, ChangeStepAction>(
  GenerateQuestionStep.Settings,
  stepReducer
);

const { Provider: StepAtomProvider, useAtom } = createIsolation();
export const useScopedStepAtom = () => useAtom(stepAtom);
export { StepAtomProvider };
